import React, { useEffect } from "react";
import {
  Dialog,
  DialogContent,
} from "../../../../Components/ui/dialog";
import CreateContentWhatsapp from "./CreateContentWhatsappCard";
import CreateContentSMS from "./CreateContentSMSCard";

interface EditTemplateDialogProps {
  open: boolean;
  onClose: () => void;
  channel: string;
  templateId: string | number;
  country: string;
  initialContent?: any;
  onSave: (content: any) => void;
  allTemplates: any[];
  configIdx: number;
}


// --- Robust normalization for WhatsApp/SMS templates (handles all API shapes) ---
function normalizeTemplateContent(input: any, channelType: string): any {
  // WhatsApp Template normalization
  if (channelType.toLowerCase() === "whatsapp") {
    let tpl =
      input?.template ||
      input?.template_content ||
      input?.translated_template?.template ||
      input?.translated_template ||
      input;

    let mediaConfig =
      input?.media_config ||
      input?.template_content?.media_config ||
      input?.translated_template?.media_config ||
      tpl?.media_config;

    let mediaBase64 = "";
    if (mediaConfig && mediaConfig.file_type && mediaConfig.binary_data) {
      mediaBase64 = mediaConfig.binary_data.startsWith("data:")
        ? mediaConfig.binary_data
        : `data:${mediaConfig.file_type};base64,${mediaConfig.binary_data.replace(/^data:[^,]+,/, "")}`;
    }

    

    return {
      name: tpl?.name || input?.name,
      language: tpl?.language || input?.language,
      category: tpl?.category || "MARKETING",
      components: tpl?.components || [],
      Base64: mediaBase64,
      media_config: mediaConfig || {},
      template_id: tpl?.template_id || input?.template_id || "",
  phone_id: input?.phone_id || tpl?.phone_id || "",
  channel_config_id: input?.channel_config_id || tpl?.channel_config_id || "",
  _baseAllocationName: input?._baseAllocationName || tpl?.name || input?.name,
  qr: input?.qr || tpl?.qr || [],
    };
  }

  // SMS Template normalization
  if (channelType.toLowerCase() === "sms") {
    let msg =
      input?.template?.message ||
      input?.template_content?.message ||
      input?.template_content?.template?.message ||
      input?.message ||
      input?.translated_template?.template?.message ||
      input?.translated_template?.message ||
      "";

    let channel_config_id =
      input?.channel_config_id ||
      input?.template?.channel_config_id ||
      input?.translated_template?.channel_config_id ||
      "";
    return {
      template: { message: msg },
      name: input?.template?.name || input?.name || "",
      channel_config_id,
      ...input,
    };
  }

  // Default fallback
  return input;
}




const EditTemplatePopup: React.FC<EditTemplateDialogProps> = ({
  open,
  onClose,
  channel,
  templateId,
  country,
  initialContent,
  onSave,
  allTemplates,
  configIdx,
}) => {

  

  // console.log("InitialContent passed to EditTemplatePopup:", initialContent);
  // const channelLower = channel?.toLowerCase?.();
    useEffect(() => {
    if (!open) {
      document.body.style.pointerEvents = "";
    }
  }, [open]);

  // // Use robust normalization for both WhatsApp and SMS (backward compatible)
  // const normalizedContent = normalizeTemplateContent(initialContent, channel);
  console.log("InitialContent passed to EditTemplatePopup:", initialContent);
console.log("[QR CHECK] channel value:", channel, "| channelLower:", channel?.toLowerCase?.());
const channelLower = channel?.toLowerCase?.();
const normalizedContent = normalizeTemplateContent(initialContent, channel);
console.log("[QR CHECK - EditTemplatePopup] normalizedContent.qr:", JSON.stringify(normalizedContent?.qr));

  let ContentEditor = null;
  if (channelLower === "whatsapp") {
    ContentEditor = (
      <CreateContentWhatsapp
        initialContent={normalizedContent}
        allTemplates={allTemplates}
        onClose={onClose}
        onSave={onSave}
        configIdx={configIdx}
      />
    );
  } else if (channelLower === "sms") {
    ContentEditor = (
      <CreateContentSMS
        initialContent={normalizedContent}
        onClose={onClose}
        onSave={onSave}
      />
    );
  } else {
    ContentEditor = (
      <div className="p-6 text-red-500">
        Unsupported channel type: <b>{channel}</b>
      </div>
    );
  }

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-6xl w-full h-[90vh] overflow-y-auto p-6">
        <div className="-mt-1">{ContentEditor}</div>
      </DialogContent>
    </Dialog>
  );
};

export default EditTemplatePopup;
